<template>
  <div class="invoices-history">
    <div class="is-flex space-between">
      <h1 class="title is-4 has-text-primary">
        Historial de Documentos
      </h1>

      <div>
        <p>
          <a
            class="button is-primary"
            @click="downloadCfdis"
          >
            <BIcon icon="cloud-download" />
            <span> Descarga Masiva</span>
          </a>
        </p>
      </div>
    </div>

    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
    <div class="history-container">
      <b-table
        :data="invoices"
        :loading="isLoading"
        detailed
        :has-detailed-visible="(row)=>row.operation.payments.length > 0"
        :row-class="(row) => [201, 202].includes(row.operation.status) && 'is-danger'"
        mobile-cards
      >
        <template slot-scope="props">
          <b-table-column
            field="voucherSeries"
            label="Folio - Serie"
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form action="">
                      <div
                        class="modal-card"
                        style="width:250px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Buscar por Serie">
                            <b-input
                              name="voucherSeries"
                              :value="$route.query.voucherSeries"
                              placeholder="A"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                          <b-field label="Buscar por Folio">
                            <b-input
                              name="voucherConsecutive"
                              :value="$route.query.voucherConsecutive"
                              placeholder="123"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>

                <router-link
                  v-if="$route.query.voucherSeries || $route.query.voucherConsecutive"
                  style="cursor: pointer;"
                  :to="{
                    query: {
                      ...$route.query,
                      voucherSeries: undefined,
                      voucherConsecutive: undefined,
                    }
                  }"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </router-link>
              </div>
            </template>

            <span>{{ props.row.voucherSeries }}</span>
            <span style="padding: 0 .5rem;">-</span>
            <span>{{ props.row.voucherConsecutive }}</span>
          </b-table-column>

          <b-table-column
            field="voucherDate"
            label="Fecha y Hora"
          >
            {{ props.row.voucherDate | toHumanDateTime }}
          </b-table-column>

          <b-table-column
            v-if="props.row.voucherType !== 'P'"
            field="voucherTotal"
            label="Total"
            centered
          >
            {{ props.row.voucherTotal | toCurrency(props.row.voucherCurrency) }}
          </b-table-column>
          <b-table-column
            v-else
            field="voucherTotal"
            label="Total"
            centered
          >
            {{ props.row.complement.payments[0].amount
              | toCurrency(props.row.complement.payments[0].currency) }}
          </b-table-column>

          <b-table-column
            field="voucherType"
            label="Tipo"
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    v-for="t in types"
                    :key="t.value"
                    :value="t.value"
                    aria-role="listitem"
                  >
                    {{ t.label }}
                  </b-dropdown-item>
                </b-dropdown>
                <div
                  v-if="type"
                  style="cursor: pointer;"
                  @click.prevent="cleanTypeSelected"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </div>
              </div>
            </template>
            {{ voucherTypeLabel(voucherType(props.row)) }}
          </b-table-column>

          <b-table-column
            field="voucherPaymentMethod"
            label="Método de pago"
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  position="is-bottom-left"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form action="">
                      <div
                        class="modal-card"
                        style="width:200px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Tipo de documento">
                            <div class="is-flex">
                              <b-radio-button
                                v-model="voucherPaymentMethodRadioButton"
                                native-value="PUE"
                                expanded
                                type="is-primary"
                              >
                                <span>PUE</span>
                              </b-radio-button>

                              <b-radio-button
                                v-model="voucherPaymentMethodRadioButton"
                                native-value="PPD"
                                expanded
                                type="is-primary"
                              >
                                <span>PPD</span>
                              </b-radio-button>
                            </div>
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>
                <a
                  v-if="$route.query.voucherPaymentMethod"
                  style="cursor: pointer;"
                  @click="voucherPaymentMethodRadioButton = ''"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </a>
              </div>
            </template>

            <BTooltip
              v-if="isExpired(props.row)"
              type="is-danger"
              label="El tiempo de pago expiró"
            >
              <span class="tag is-danger">
                {{ props.row.voucherPaymentMethod }}
              </span>
            </BTooltip>
            <span v-else>
              {{ props.row.voucherPaymentMethod }}
            </span>
          </b-table-column>

          <b-table-column
            field="operation.cfdiStatus"
            label="Estado CFDI"
          >
            {{ getCfdiStatus(props.row) }}
          </b-table-column>

          <b-table-column
            field="id"
            label="Acciones"
          >
            <invoice-actions
              v-if="voucherType(props.row) === 'invoice'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <pre-invoice-actions
              v-if="voucherType(props.row) === 'pre'"
              :id="props.row.id"
              :voucher-type="props.row.voucherType"
              :invoice="props.row"
            />

            <auto-invoice-actions
              v-if="voucherType(props.row) === 'autoInvoice'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <credit-note-actions
              v-if="voucherType(props.row) === 'creditNote'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <payroll-actions
              v-if="voucherType(props.row) === 'payroll'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <rep-actions
              v-if="voucherType(props.row) === 'rep'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <salary-receipt-actions
              v-if="voucherType(props.row) === 'salaryReceipt'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <sale-note-actions
              v-if="voucherType(props.row) === 'saleNote'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <trade-transfer-actions
              v-if="voucherType(props.row) === 'tradeTransfer'"
              :id="props.row.id"
              :invoice="props.row"
            />
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="emoticon-sad"
                  size="is-large"
                />
              </p>
              <p>No has generado ningún documento</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>

    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters, mapActions } from 'vuex';
import utils from '../../../lib/utils';

export default {
  name: 'History',
  components: {
    AppPagination: () => import(/* webpackChunkName: "app-pagination" */ '../../../components/AppPagination.vue'),
    AutoInvoiceActions: () => import(/* webpackChunkName: "history-auto-invoice-actions" */ '../../../components/Invoices/History/AutoInvoiceActions.vue'),
    CreditNoteActions: () => import(/* webpackChunkName: "history-credit-note-actions" */ '../../../components/Invoices/History/CreditNoteActions.vue'),
    InvoiceActions: () => import(/* webpackChunkName: "history-invoice-actions" */ '../../../components/Invoices/History/InvoiceActions.vue'),
    PayrollActions: () => import(/* webpackChunkName: "history-payroll-actions" */ '../../../components/Invoices/History/PayrollActions.vue'),
    PreInvoiceActions: () => import(/* webpackChunkName: "history-preinvoice-actions" */ '../../../components/Invoices/History/PreInvoiceActions.vue'),
    RepActions: () => import(/* webpackChunkName: "history-rep-actions" */ '../../../components/Invoices/History/RepActions.vue'),
    SalaryReceiptActions: () => import(/* webpackChunkName: "history-salary-receipt-actions" */ '../../../components/Invoices/History/SalaryReceiptActions.vue'),
    SaleNoteActions: () => import(/* webpackChunkName: "history-sale-note-actions" */ '../../../components/Invoices/History/SaleNoteActions.vue'),
    TradeTransferActions: () => import(/* webpackChunkName: "history-trade-transfer-actions" */ '../../../components/Invoices/History/TradeTransferActions.vue'),
  },
  data() {
    return {
      voucherPaymentMethodRadioButton: '',
      isLoading: false,
      buttonsMax: 5,
      modal: false,
      invoiceToCanel: '',
      type: '',
      types: [
        {
          value: 'pre',
          label: 'Pre Factura',
        },
        {
          value: 'invoice',
          label: 'Factura',
        },
        {
          value: 'creditNote',
          label: 'Nota de Crédito',
        },
        {
          value: 'payroll',
          label: 'Nómina',
        },
        {
          value: 'tradeTransfer',
          label: 'Traslado',
        },
        {
          value: 'rep',
          label: 'REP',
        },
        {
          value: 'saleNote',
          label: 'Nota de Remisión',
        },
        {
          value: 'auto',
          label: 'Auto Factura',
        },
        {
          value: 'salaryReceipt',
          label: 'Recibo de Salario',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      total: state => state.invoices.total,
      totalPages: state => state.invoices.totalPages,
    }),
    ...mapGetters({
      invoices: 'invoices/cleanInvoices',
    }),
    isExpired() {
      return (row) => {
        if (row.voucherPaymentMethod !== 'PPD') return null;
        return moment(row.operation.expirationDate) < moment();
      };
    },
    voucherType() {
      return invoice => utils.getDocumentType(invoice);
    },
    voucherTypeLabel() {
      return (type) => {
        let label = 'Pre Factura';

        switch (type) {
          case 'invoice':
            label = 'Factura';
            break;
          case 'creditNote':
            label = 'Nota de Crédito';
            break;
          case 'payroll':
            label = 'Nómina';
            break;
          case 'tradeTransfer':
            label = 'Traslado';
            break;
          case 'rep':
            label = 'REP';
            break;
          case 'saleNote':
            label = 'Nota de Remisión';
            break;
          case 'autoInvoice':
            label = 'Auto Factura';
            break;
          case 'salaryReceipt':
            label = 'Recibo de Salario';
            break;
          default:
            break;
        }

        return label;
      };
    },
    lastPage() {
      return Math.ceil(this.invoices.length / this.itemsPerPage);
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10);
    },
    size() {
      return this.$route.query.size;
    },
  },
  watch: {
    voucherPaymentMethodRadioButton(value) {
      if (!value) {
        this.$router.push({ query: { ...this.$route.query, voucherPaymentMethod: undefined } });
      } else {
        this.$router.push({ query: { ...this.$route.query, voucherPaymentMethod: value } });
      }
    },
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ name: to.name, query: { page: 1, size: 20 } });
    }
  },
  methods: {
    ...mapActions({
      getAll: 'invoices/getAll',
      cancelByUuid: 'invoice/cancelByUuid',
    }),
    async downloadCfdis() {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('invoices/getAll', {
        ...this.$route.query,
        filter: 'download',
        download: true,
        'operation.customer': this.$route.params.customer,
      });

      this.$store.commit('ui/deleteNotification', now);
    },
    onChangeType(type) {
      this.$router.push({ query: { page: 1, size: 20, filter: type } });
    },
    cleanTypeSelected() {
      this.type = '';
      this.$router.push({ query: { page: 1, size: 20, filter: '' } });
    },
    goToPage(page) {
      const { size = 20 } = this.$route.query;

      const query = {
        page,
        size,
      };

      this.$router.push({ query });
    },
    checkLastPage() {
      if (this.currentPage < this.lastPage) {
        this.$router.push({ query: { page: this.lastPage } });
      }
    },
    onInputSearcherRouter(event) {
      this.$router.push({
        query: { ...this.$route.query, [event.target.name]: event.target.value },
      });
    },
    getCfdiStatus(row) {
      const documents = [
        'invoice',
        'creditNote',
        'tradeTransfer',
        'payroll',
        'rep',
      ];

      const documentType = this.voucherType(row);

      if (([201, 202].includes(row.operation.status) && !row.operation.cfdiStatus)
        || !documents.includes(documentType)) {
        return '';
      }

      return row.operation.cfdiStatus || 'Vigente';
    },
  },
};
</script>

<style scoped>
.history-container {
  margin-top: 2rem;
}

.router-link-active span.icon.is-small {
  color: white !important;
}

.invoices-history {
  padding: 1rem;
}

.menu-docs {
  display: flex;
  flex-direction: row;
  padding-bottom: 1.5rem;
}

.field.has-addons {
  margin-bottom: 1.5rem;
}

.is-flex.space-between {
  justify-content: space-between;
}
</style>

<style>
.invoices-history .field.has-addons a.router-link-active.button .icon {
  color: white!important;
}

.invoices-history .action-option {
  display: flex;
  flex-direction: column;
}

.invoices-history .b-table .table th .th-wrap .dropdown-trigger .icon {
  margin-left: 0;
}

.invoices-history .b-table .table th {
  vertical-align: middle;
}

.invoices-history .is-flex.voucher-type-selector {
  justify-content: space-between;
  align-items: center;
}

.invoices-history .voucher-type-selector .filter {
  cursor: pointer;
}
</style>
